module.exports = __webpack_public_path__ + "static/media/world_n.6395556b.png";